import React from 'react';

import Filterable from '@components/Filterable/Filterable';
import InputsList from './InputsList';
import InputsSet from './constants/inputsSet';
import { FILTERS } from './constants';

/*
  Presentational component for Inputs
*/

const Inputs = () => (
  <Filterable
    customClasses={'main-content'}
    filters={FILTERS}
    data={InputsSet}
    withoutSearch
  >
    <InputsList/>
  </Filterable>
);

Inputs.displayName = 'InputsPage';

export default Inputs;


// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/Inputs.js